export const CountryCodes = [
  { value: 'IT', text: 'IT' },
  { value: 'EN', text: 'EN' },
  { value: 'FR', text: 'FR' },
  { value: 'DE', text: 'DE' }
]
